<template>
  <coin-list :realtime="true"></coin-list>
</template>

<script>
import CoinList from "./coinlist";

export default {
  components: { CoinList },
};
</script>
